import Spinner from "react-bootstrap/Spinner";

const ContentLoading = ({
  children,
  isLoading,
  className = "",
  height = "400px",
  iconWidth = "200px",
  marginTop = "100px",
  ...reset
}) => {
  return (
    <>
      {isLoading ? (
        <div style={{ height: height, textAlign: "center" }}>
          {/* <Spinner
            animation="grow"
            variant="primary"
            size="lg"
            style={{ width: "100px", height: "100px", marginTop: "100px" }}
          /> */}
          <img
            src={`${process.env.PUBLIC_URL}/loading2.gif`}
            style={{ width: iconWidth, height: "auto", marginTop: marginTop }}
          />
        </div>
      ) : (
        <div className={className} {...reset}>
          {children}
        </div>
      )}
    </>
  );
};

export default ContentLoading;
